import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UsersService } from 'src/app/core/services';
import { AdminApplicationService } from 'src/app/core/services/admin/admin-application.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {
  public currentUser;
  public isApplicationEditable = false;
  constructor(
    private router: Router,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private adminService: AdminApplicationService
  ) { }

  ngOnInit() {
    /** GET CURRENT ROUTE */
    this.authenticationService.getUserInfo().subscribe(user => {
      this.currentUser = user ? user : null;
    });
  }

  logout() {
    this.authenticationService.logout().subscribe(data => {
      if (data) {
        this.router.navigate(['']);
      }
    })
  }

}
